import React from 'react'
import '../App.css'
import Bodyhomeadminusers from './bodyhomeadminusers'
export class Bodyapphomebodyadminusers extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodyhomeadminusers />
                </div>
            </div>
        );
    }
}